export default {
  "content": "<path d=\"M368 415.86V72a24.07 24.07 0 00-24-24H72a24.07 24.07 0 00-24 24v352a40.12 40.12 0 0040 40h328\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M416 464a48 48 0 01-48-48V128h72a24 24 0 0124 24v264a48 48 0 01-48 48zM240 128h64m-64 64h64m-192 64h192m-192 64h192m-192 64h192\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M176 208h-64a16 16 0 01-16-16v-64a16 16 0 0116-16h64a16 16 0 0116 16v64a16 16 0 01-16 16z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};